<script setup>
import { computed } from 'vue'

const ID_PATTERN = /^[A-Za-z0-9_-]{11}$/
const URL_PATTERN = /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/

const props = defineProps({
	youtubeId: {
		type: String,
		default: null,
	},
})

const id = computed(() => {
	const value = (props.youtubeId || '').trim()

	if (ID_PATTERN.test(value)) {
		return value
	}

	return value.match(URL_PATTERN)?.[1] ?? null
})

const src = computed(() => (id.value ? `https://www.youtube.com/embed/${id.value}?modestbranding=1&enablejsapi=1&widgetid=3&showinfo=0&iv_load_policy=3&fs=1` : null))
</script>

<template>
	<div v-if="src" class="aspect-video w-full overflow-hidden rounded-lg bg-black">
		<iframe width="100%" height="100%" :src="src" frameborder="0" allowfullscreen></iframe>
	</div>
</template>
